import { render } from "./DiyModal.vue?vue&type=template&id=68064026&scoped=true"
import script from "./DiyModal.vue?vue&type=script&lang=js"
export * from "./DiyModal.vue?vue&type=script&lang=js"

import "./DiyModal.vue?vue&type=style&index=0&id=68064026&scoped=true&lang=css"
import "./DiyModal.vue?vue&type=style&index=1&id=68064026&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LewisLi\\workitem\\th workspace\\th_fe\\tiffanyFE-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68064026"]])

export default __exports__